import type { FilterType } from "./types";

export enum DisplayVariant {
  Variant1 = "VARIANT_1",
}

export enum ExhibitorPageType {
  Listing,
  FeaturedListing,
  ExhibitorProfile,
  ProductPage,
  ResourcePage,
}

export enum DisplayView {
  List,
  Grid,
  Thumbs,
}

export enum DisplayType {
  Exhibitors,
  Products,
  Resources,
}

export enum ResourceType {
  Image = "jpg",
  Video = "url",
  PDF = "pdf",
}

export enum ContentTabType {
  Products,
  Resources,
  AssociatedBrands,
  Contacts,
}

export const FILTER_TYPE_ORDER: FilterType[] = [
  "categories",
  "countries",
  "exhibitortype",
  "nob",
  "shows",
  "projectType",
  "projectLocation",
  "projectBudget",
  "pavilion",
  "package",
  "hall",
];

export const FILTER_VALUE_PREFIX = "_$_";
export const MAX_VISIBLE_FILTER_AMOUNT = 5;
export const MAX_VISIBLE_PRODUCTS_AMOUNT = 5;
export const EXHIBITORS_PATHNAME = "exhibitors";
export const PRODUCTS_PATHNAME = "products";
export const RESOURCES_PATHNAME = "resources";
export const FEATURED_PRODUCTS_PATHNAME = "featured-products";
